module.exports = __webpack_public_path__ + "static/media/Panorama_CE24CANIMOLT.0e4d3484.pdf";